import {DNDComponentProps} from "../../dnd/dnd-component"

import Board_Manager from "./managers/manager"
import ItemModelV2 from "../../../model2/item2/item-model"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import {SystemStatus} from "../../../gd/const/system-status"
import {ProjectItem} from "../../../model2/project-item/project-item"

export type Board_SkinCard_ViewProps = DNDComponentProps & {
    manager         : Board_Manager
    listItem        : ItemModelV2

    cardSize?       : Board_CardSize

    isSingleColumn? : boolean
    isPreview?      : boolean
    showDetailed    : boolean
    disableReorder? : boolean

    changePosition? : callback
}

export enum Board_CardSize {
    SMALL   = 'small',
    MEDIUM  = 'medium',
    LARGE   = 'large',
}

export type Board_AggregateParameters = {
    fieldId?    : ID,
    function?   : AggregateFunctionType
}

export type Board_CellValue = {
    id?             : ID
    label           : string

    // for status row/column
    systemStatus?   : SystemStatus

    // custom field specific
    customFieldId?  : ID
    value?          : any
}

export type Board_CellData = {
    group1Value : Board_CellValue
    group2Value : Board_CellValue
}

export type BoardCard_DragStartData = {
    originItemData      : Board_CellData,
    originalProjects    : ProjectItem[]
}

export type BoardCard_DragHandleParams = {
    dragStartData   : BoardCard_DragStartData,
    targetItemData  : Board_CellData,
    noParentChange  : boolean
    noRequest       : boolean
}